import { render, staticRenderFns } from "./FormImageUploader.vue?vue&type=template&id=2e0c2a45&scoped=true&"
import script from "./FormImageUploader.vue?vue&type=script&lang=js&"
export * from "./FormImageUploader.vue?vue&type=script&lang=js&"
import style0 from "./FormImageUploader.vue?vue&type=style&index=0&id=2e0c2a45&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0c2a45",
  null
  
)

export default component.exports